import Layout from "../../components/Layout"
import CustomerManagementTabs from "../../components/Tabs/CustomerManagementTabs"
import { Box, Paper } from "@mui/material"
import { useDispatch } from "react-redux"
import { setLoading, setOpenSidebar } from "../../redux/slices/appSlice"
import CustomerManagementHeader from "../../components/Headers/CustomerManagementHeader"
import { CMPaper } from "./Atom"
import { getTokenLocal } from "../../../helper/utils"
import {
  setGroupData,
  setGroupDetailsRegions,
  setGroupInfo,
  setGroupProfileDetails,
  setMetricDetailsBuckets,
  setPracticeList,
} from "../../redux/slices/groupProfileSlice"
import { useEffect } from "react"
import CustomerMangementAPI from "../../../api/customerMangement"
import GroupProfileAPI from "../../../api/groupProfile"
import { useResponseHandle } from "../../hooks"
import { useNavigate } from "react-router"

const customerMangementAPI = new CustomerMangementAPI()
const groupProfileAPI = new GroupProfileAPI()

function CustomerManagement() {
  const token: any = getTokenLocal()

  const dispatch = useDispatch()
  const navigate = useNavigate()

  dispatch(setOpenSidebar(false))

  const handleGroupFetch = async () => {
    dispatch(setLoading(true))
    const response = await customerMangementAPI.getAssignedAndUnAssignedGroups(
      token,
      true ? "assigned" : "unassigned",
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      dispatch(setGroupData(result?.data))
      dispatch(setLoading(false))
      return result
    } else {
      navigate("/auth")
    }

    dispatch(setLoading(false))
  }

  const handleGroupFetchAssigned = async (flag: string) => {
    dispatch(setLoading(true))
    const response = await customerMangementAPI.getAssignedAndUnAssignedGroups(
      token,
      flag,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      dispatch(setGroupData(result?.data))
      dispatch(setLoading(false))
      return result
    } else {
      navigate("/auth")
    }

    dispatch(setLoading(false))
  }

  const handleGroupFetchUnAssigned = async (flag: string) => {
    dispatch(setLoading(true))
    const response = await customerMangementAPI.getAssignedAndUnAssignedGroups(
      token,
      flag,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      dispatch(setGroupData(result?.data))
      dispatch(setLoading(false))
      return result
    } else {
      navigate("/auth")
    }

    dispatch(setLoading(false))
  }

  const groupInfoHandler = async (group_sk: any) => {
    const response = await groupProfileAPI.getgroupInfoById(token, group_sk)
    const response2 = await groupProfileAPI.getAllPractices(token, group_sk)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    const result2 = useResponseHandle({
      apiResponse: response2,
      successMessage: false,
    })

    if (result2?.isAuthorized) {
      dispatch(setPracticeList(result2?.data))
    } else {
      navigate("/auth")
    }

    if (result?.isAuthorized) {
      dispatch(setGroupInfo(result?.data))
      return result
    } else {
      navigate("/auth")
    }
  }

  const metricDetailsHandler = async (group_sk: any) => {
    const response = await groupProfileAPI.getMetricDetailsById(token, group_sk)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      const buckets = result?.data?.data.map((bucketName: any) => {
        return bucketName.metric_bucket
      })
      dispatch(setMetricDetailsBuckets(buckets))
      dispatch(setGroupProfileDetails(result?.data?.data))
      return result
    } else {
      navigate("/auth")
    }
  }

  const groupDetailsHandler = async (group_sk: any) => {
    const response = await groupProfileAPI.getGroupDetailsRegionsByGroups(
      token,
      [group_sk],
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      dispatch(setGroupDetailsRegions(result?.data))
      return result
    } else {
      navigate("/auth")
    }
  }

  useEffect(() => {
    handleGroupFetch()
  }, [])

  return (
    <Box sx={{ backgroundColor: "#F8F9FA" }}>
      <CustomerManagementHeader name="Customer Management" />
      <CMPaper>
        <CustomerManagementTabs
          handleGroupFetchAssigned={handleGroupFetchAssigned}
          handleGroupFetchUnAssigned={handleGroupFetchUnAssigned}
          groupInfoHandler={groupInfoHandler}
          metricDetailsHandler={metricDetailsHandler}
          groupDetailsHandler={groupDetailsHandler}
        />
      </CMPaper>
    </Box>
  )
}

export default CustomerManagement
